export default __webpack_public_path__ + "static/media/card-add-to-cart-icon.befd8349.svg";